import {
	IconButton,
	Table,
	TableBody,
	TableCell,
	tableCellClasses,
	TableContainer,
	TableHead,
	TableRow,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import * as React from "react";

import {
	AddRounded,
	DeleteOutlineRounded,
	DoneRounded,
	EditRounded,
} from "@mui/icons-material";
import { useContext, useState } from "react";
import APIContext from "../../context/APIContext";
import ControlContext from "../../context/ControlContext";
import DropdownInput from "../reusable/DropdownInput";
import TextInputField from "../reusable/TextInputField";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
	[`&.${tableCellClasses.head}`]: {
		backgroundColor: theme.palette.common.black,
		color: theme.palette.common.white,
		padding: 0,
		textAlign: "center",
	},
	[`&.${tableCellClasses.body}`]: {
		fontSize: 12,
		padding: 0,
		textAlign: "center",
	},
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
	"&:nth-of-type(odd)": {
		backgroundColor: theme.palette.action.hover,
	},
	// hide last border
	"&:last-child td, &:last-child th": {
		border: 0,
	},
}));

const SalesTable = ({
	setgridValues,
	gridValues,
	salesRecord,
	setSalesRecord,
	defaultSalesRecord,
}) => {
	//  onChange function for the form values
	const handleChange = (prop) => (event) => {
		setSalesRecord({ ...salesRecord, [prop]: event.target.value });
	};

	let [editting, setEditting] = useState(false);

	let {
		handleAddRecord,
		handleSaveEdit,
		handleDeleteRecord,
		handleEditRecord,
	} = useContext(ControlContext);

	let { mcType } = useContext(APIContext);

	return (
		<TableContainer
			sx={{ height: 200, border: "1px solid gray", borderRadius: "5px" }}
		>
			<Table>
				<TableHead>
					<TableRow>
						<StyledTableCell>S#</StyledTableCell>
						<StyledTableCell> ItemCode</StyledTableCell>
						<StyledTableCell>ItemName</StyledTableCell>
						<StyledTableCell>Purity</StyledTableCell>
						<StyledTableCell>McType</StyledTableCell>
						<StyledTableCell>Qty</StyledTableCell>
						<StyledTableCell>GrossWgt</StyledTableCell>
						<StyledTableCell>StoneWgt</StyledTableCell>
						<StyledTableCell>NetWgt</StyledTableCell>
						<StyledTableCell>PureWgt</StyledTableCell>
						<StyledTableCell>RateGm</StyledTableCell>
						<StyledTableCell>TotalAmt</StyledTableCell>
						<StyledTableCell></StyledTableCell>
					</TableRow>
					<TableRow>
						<StyledTableCell>
							<TextInputField
								value={salesRecord.serial}
								onChange={handleChange("serial")}
							/>
						</StyledTableCell>
						<StyledTableCell>
							<TextInputField
								value={salesRecord.itemCode}
								onChange={handleChange("itemCode")}
							/>
						</StyledTableCell>
						<StyledTableCell>
							<TextInputField
								value={salesRecord.itemName}
								onChange={handleChange("itemName")}
							/>
						</StyledTableCell>
						<StyledTableCell>
							<TextInputField
								value={salesRecord.purity}
								onChange={handleChange("purity")}
							/>
						</StyledTableCell>
						<StyledTableCell>
							<DropdownInput
								options={mcType}
								value={salesRecord.mcType}
								onChange={handleChange("mcType")}
							/>
						</StyledTableCell>
						<StyledTableCell>
							<TextInputField
								value={salesRecord.qty}
								onChange={handleChange("qty")}
							/>
						</StyledTableCell>
						<StyledTableCell>
							<TextInputField
								value={salesRecord.grossWgt}
								onChange={handleChange("grossWgt")}
							/>
						</StyledTableCell>
						<StyledTableCell>
							<TextInputField
								value={salesRecord.stoneWgt}
								onChange={handleChange("stoneWgt")}
							/>
						</StyledTableCell>
						<StyledTableCell>
							<TextInputField
								value={salesRecord.netWgt}
								onChange={handleChange("netWgt")}
							/>
						</StyledTableCell>
						<StyledTableCell>
							<TextInputField
								value={salesRecord.pureWgt}
								onChange={handleChange("pureWgt")}
							/>
						</StyledTableCell>
						<StyledTableCell>
							<TextInputField
								value={salesRecord.rateGm}
								onChange={handleChange("rateGm")}
							/>
						</StyledTableCell>
						<StyledTableCell>
							<TextInputField
								value={salesRecord.totalAmt}
								onChange={handleChange("totalAmt")}
							/>
						</StyledTableCell>
						<StyledTableCell>
							{!editting ? (
								<IconButton
									onClick={() =>
										handleAddRecord(
											setSalesRecord,
											gridValues,
											setgridValues,
											salesRecord,
											defaultSalesRecord
										)
									}
									color="primary"
									component="label"
								>
									<AddRounded />
								</IconButton>
							) : (
								<IconButton
									onClick={() =>
										handleSaveEdit(
											salesRecord.itemCode,
											setSalesRecord,
											gridValues,
											salesRecord,
											defaultSalesRecord,
											setgridValues,
											setEditting
										)
									}
									color="primary"
									component="label"
								>
									<DoneRounded />
								</IconButton>
							)}
						</StyledTableCell>
					</TableRow>
				</TableHead>
				<TableBody>
					{gridValues.length !== undefined && gridValues.length > 0
						? gridValues.map((row, index) => (
								<StyledTableRow key={index}>
									<StyledTableCell component="th" scope="row">
										{row.serial || index}
									</StyledTableCell>
									<StyledTableCell>{row.itemCode}</StyledTableCell>
									<StyledTableCell>{row.itemName}</StyledTableCell>
									<StyledTableCell>{row.purity}</StyledTableCell>
									<StyledTableCell>{row.mcType}</StyledTableCell>
									<StyledTableCell>{row.qty}</StyledTableCell>
									<StyledTableCell>{row.grossWgt}</StyledTableCell>
									<StyledTableCell>{row.stoneWgt}</StyledTableCell>
									<StyledTableCell>{row.netWgt}</StyledTableCell>
									<StyledTableCell>{row.pureWgt}</StyledTableCell>
									<StyledTableCell>{row.rateGm}</StyledTableCell>
									<StyledTableCell>{row.totalAmt}</StyledTableCell>
									<StyledTableCell
										sx={{ display: "flex", alignItems: "center" }}
									>
										<IconButton
											onClick={() =>
												handleEditRecord(
													row.itemCode,
													setSalesRecord,
													gridValues,
													setEditting
												)
											}
											color="secondary"
											component="label"
										>
											<EditRounded sx={{ fontSize: 14 }} />
										</IconButton>
										<IconButton
											onClick={() =>
												handleDeleteRecord(
													row.itemCode,
													gridValues,
													setgridValues,
													setSalesRecord,
													defaultSalesRecord
												)
											}
											color="error"
											component="label"
										>
											<DeleteOutlineRounded sx={{ fontSize: 14 }} />
										</IconButton>
									</StyledTableCell>
								</StyledTableRow>
						  ))
						: null}
				</TableBody>
			</Table>
		</TableContainer>
	);
};

export default SalesTable;
